import type { CourseNature } from "../../storage/resourceRoomDocument";
import type {
  StudentTimetableWorkbook,
  WorkbookCell
} from "../student-timetables/studentTimetableWorkbook";

export const demoStudentProfiles = [
  { importKey: "林晓", grade: "三年级", className: "1班" },
  { importKey: "周然", grade: "三年级", className: "2班" },
  { importKey: "陈可", grade: "四年级", className: "1班" },
  { importKey: "赵宁", grade: "四年级", className: "3班" },
  { importKey: "苏悦", grade: "五年级", className: "2班" }
] as const;

export const demoInterventionCourseNames = ["社交沟通", "感觉统合", "学习策略"] as const;
export const demoTeacherNames = ["王老师", "李老师", "陈老师"] as const;
export const demoRoomNames = ["资源教室", "感统训练室"] as const;

const headers = ["节次/时间", "星期一", "星期二", "星期三", "星期四", "星期五"];
const timeLabels = [
  "第1节 08:00-08:40",
  "第2节 08:50-09:30",
  "第3节 09:50-10:30",
  "第4节 10:40-11:20",
  "第5节 13:30-14:10",
  "第6节 14:20-15:00",
  "第7节 15:20-16:00",
  "第8节 16:10-16:50"
];

const schedules: Record<(typeof demoStudentProfiles)[number]["importKey"], string[][]> = {
  林晓: [
    ["语文", "数学", "语文", "英语", "数学"],
    ["数学", "语文", "数学", "语文", "语文"],
    ["英语", "美术", "科学", "音乐", "体育"],
    ["体育", "英语", "音乐", "数学", "美术"],
    ["美术", "道德与法治", "体育", "科学", "音乐"],
    ["音乐", "体育", "美术", "班会", "劳动"],
    ["劳动", "信息技术", "综合实践", "美术", "体育"],
    ["班会", "综合实践", "信息技术", "劳动", "科学"]
  ],
  周然: [
    ["数学", "语文", "英语", "数学", "语文"],
    ["语文", "数学", "语文", "英语", "数学"],
    ["科学", "美术", "体育", "音乐", "道德与法治"],
    ["音乐", "英语", "美术", "语文", "体育"],
    ["美术", "科学", "体育", "道德与法治", "音乐"],
    ["体育", "音乐", "劳动", "班会", "美术"],
    ["信息技术", "综合实践", "美术", "体育", "劳动"],
    ["班会", "劳动", "信息技术", "综合实践", "科学"]
  ],
  陈可: [
    ["语文", "英语", "数学", "语文", "数学"],
    ["数学", "语文", "英语", "数学", "语文"],
    ["英语", "美术", "科学", "音乐", "体育"],
    ["体育", "数学", "音乐", "英语", "美术"],
    ["美术", "道德与法治", "体育", "科学", "音乐"],
    ["音乐", "体育", "美术", "班会", "劳动"],
    ["劳动", "信息技术", "综合实践", "美术", "体育"],
    ["班会", "综合实践", "信息技术", "劳动", "科学"]
  ],
  赵宁: [
    ["英语", "数学", "语文", "数学", "语文"],
    ["语文", "英语", "数学", "语文", "数学"],
    ["科学", "美术", "体育", "音乐", "道德与法治"],
    ["音乐", "语文", "美术", "英语", "体育"],
    ["美术", "科学", "体育", "道德与法治", "音乐"],
    ["体育", "音乐", "劳动", "班会", "美术"],
    ["信息技术", "综合实践", "美术", "体育", "劳动"],
    ["班会", "劳动", "信息技术", "综合实践", "科学"]
  ],
  苏悦: [
    ["语文", "数学", "英语", "语文", "数学"],
    ["数学", "语文", "数学", "英语", "语文"],
    ["英语", "美术", "科学", "音乐", "体育"],
    ["体育", "英语", "音乐", "数学", "美术"],
    ["美术", "道德与法治", "体育", "科学", "音乐"],
    ["音乐", "体育", "美术", "班会", "劳动"],
    ["劳动", "信息技术", "综合实践", "美术", "体育"],
    ["班会", "综合实践", "信息技术", "劳动", "科学"]
  ]
};

const protectedCourses = new Set(["语文", "数学", "英语"]);
const preferredCourses = new Set([
  "美术",
  "音乐",
  "体育",
  "劳动",
  "信息技术",
  "班会",
  "综合实践"
]);

function textCell(value: string): WorkbookCell {
  return { kind: "text", value };
}

export function buildDemoStudentTimetableWorkbook(): StudentTimetableWorkbook {
  return {
    sheets: demoStudentProfiles.map((student) => ({
      name: student.importKey,
      merged_ranges: [],
      rows: [
        headers.map(textCell),
        ...schedules[student.importKey].map((courses, index) =>
          [timeLabels[index], ...courses].map(textCell)
        )
      ]
    }))
  };
}

export function demoCourseNature(courseName: string): CourseNature {
  if (protectedCourses.has(courseName)) return "PROTECTED";
  if (preferredCourses.has(courseName)) return "PREFERRED";
  return "GENERAL";
}

export function demoProjectName(): string {
  const stamp = new Intl.DateTimeFormat("zh-CN", {
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false
  }).format(new Date()).replaceAll("/", "-");
  return `本地全流程测试 ${stamp}`;
}
